;
define("product_list_details_later_macro.tpl", function(){});

